import config from 'emun.retailer/retailer.config'
import $appConfig from 'servicestack/config'

class DashboardItemsAbandonedController  {
    constructor(createAutoQuery, $session, $scope) {
        let $ctrl = this;
        let options = {
            url: 'QueryAbandonedItemTotals.json',
            criteria: {
                dateRange: $ctrl.date,
                startDate: $ctrl.start,
                endDate: $ctrl.end,
                vendorId: $ctrl.vendor
            },
            autoLoad: true,
            take: $ctrl.top
        };
        $ctrl.query = createAutoQuery(options);
        $ctrl.productImage = $appConfig.productImage;
        $ctrl.$session = $session;
        $scope.$watch("$ctrl.date", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.start", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.end", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.vendor", function () {
            $ctrl.reload();
        });
    }
    reload() {
        this.query.criteria.dateRange = this.date;
        this.query.criteria.startDate = this.start;
        this.query.criteria.endDate = this.end;
        this.query.criteria.vendorId = this.vendor;
        this.query.load(true);
    }
}

class DashboardItemsAbandoned{
    constructor(){
        this.bindings= {
            date: '@',
            start: '@',
            end: '@',
            top: '@',
            vendor: '@'
        };
        this.controller = DashboardItemsAbandonedController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-items-abandoned.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardItemsAbandoned', new DashboardItemsAbandoned());

export default DashboardItemsAbandoned